module Dashboard {
    "use strict";

    export interface IWidgetConfig {
        /** Randomly generated string, for identifying widget */
        id: string;

        /** For newcomers who don't have a config saved, is the widget rendered by default? */
        enabledByDefault: boolean;

        /** Name of the widget, displayed in the Add Widgets menu */
        displayName: string;

        /** Must match the widget's directive name (as would be used in HTML) */
        directiveName: string;

        /** Optional- Default size and position of widget */
        gridItemConfig?: IGridItemConfig;

        /** List of environments, used for filtering widget data */
        environments: string[];
    }

    export interface IWidgetConfigWithTimeRange extends IWidgetConfig {
        rangeInDays: number;
    }

    export interface IGridItemConfig {
        col: number;
        row: number;
        sizeX: number;
        sizeY: number;
        disableResizing?: boolean; // Set to true if the resizing functionality should be disabled for a specific widget type
    }    
}